import { MetadataFieldWithValue } from '@/model/Metadata.model';
import { components } from '@/generated/internal-api/openapi-types';
import { ID } from '@/model/Common.model';
import { StrainApiId } from '@/model/Strain.model';
import { TempAnimalApiId, TempAnimalDefinitionApiId } from '@/model/SamplePlan.model';

export type AnimalDefinitionApiId = components['schemas']['AnimalDefinitionApiId.schema'];

export interface PlannedAnimal {
  temp_id: TempAnimalApiId | TempAnimalDefinitionApiId;
  name: string;
  group_temp_id?: string;
  sex: string;
  dob?: string;
  species?: string;
  strain?: string;
  strainApiId?: StrainApiId;
  metadata?: Record<ID, MetadataFieldWithValue>;
}

export type PlannedAnimalData =
  | { type: 'planned'; animals: Array<PlannedAnimal> }
  | {
      type: 'registered';
      animalsPerCage: number;
      animals: Array<PlannedAnimal>;
    }
  | { type: 'skip' };

export type PlanTypes = PlannedAnimalData['type'];

export const PlanTypeMap = {
  planned: 'planned',
  registered: 'registered',
  skip: 'skip',
} as const;

export type AnimalDefinitionUpsertV1 = components['schemas']['AnimalDefinitionUpsertV1.schema'];
export type AnimalCreateFromDefinitionV1 = components['schemas']['AnimalCreateFromDefinitionV1.schema'][];
export type AnimalDefinitionMappingV1 = components['schemas']['AnimalDefinitionMappingV1.schema'];
export type AnimalCreateV1 = components['schemas']['AnimalCreateV1.schema'];
export type AnimalMapV1 = components['schemas']['AnimalMapV1.schema'];
export type AnimalDefinitionTargetAnimal = components['schemas']['AnimalDefinitionTargetAnimalV1.schema'];
